/** @format */

import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconMoneyScorecardGold
} from '@dsg-tech/homefield-angular-icons';
import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'pdp-product-availability-notification-gold-message',
	templateUrl: './product-availability-notification-gold-message.component.html',
	styleUrl: './product-availability-notification-gold-message.component.scss',
	imports: [HomefieldIconLibraryModule, HmfTextLinkComponent, NgClass]
})
export class ProductAvailabilityNotificationGoldMessageComponent {
	@Input()
	public isPanelText: boolean;

	@Input()
	public showDetailsLink: boolean;

	public detailsLink = '/s/scorecard-benefits';
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconMoneyScorecardGold]);
	}
}
